import { createAction } from '@reduxjs/toolkit'

import { GlobalCredentialsGroup } from 'types/GlobalCredentials'

// tryGetAllCredentialsGroups
export const getAll = createAction('get_all_credentials_groups')
export const getAllSuccess = createAction<{ data: GlobalCredentialsGroup[] }>(
  'get_all_credentials_groups_success'
)
export const getAllFailed = createAction('get_all_credentials_groups_failed')

// tryCreateCredentialsGroups
export const create = createAction('create_credentials_group')
export const createSuccess = createAction<{ data: GlobalCredentialsGroup }>(
  'create_credentials_group_success'
)
export const createFailed = createAction('create_credentials_group_failed')

// tryDeleteCredentialsGroups
export const destroy = createAction('destroy_credentials_group')
export const destroySuccess = createAction<string>(
  'destroy_credentials_group_success'
)
export const destroyFailed = createAction('destroy_credentials_group_failed')
